import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.312 9.497V7.933c0-.681.15-1.047 1.26-1.047h1.363V4.25H13.84c-2.636 0-3.682 1.728-3.682 3.683v1.576H8.065v2.61h2.094v7.631h3.14v-7.63h2.308l.315-2.623H13.3h.013Z"
    }, null, -1)
  ])))
}
export default { render: render }